import { workspaceMenu, servicesMenu, financeMenu, managementMenu, systemMenu } from './panel';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [workspaceMenu, servicesMenu, financeMenu, managementMenu, systemMenu],
  urlMap: {}
};

// Initialize urlMap
menuItems.urlMap = menuItems.items.reduce((map, item) => {
  item.children.forEach((child) => {
    if (child.url) {
      map[child.url] = child;
    }
  });
  return map;
}, {});

export default menuItems;
